import { render, staticRenderFns } from "./HeaderDetail.vue?vue&type=template&id=c5a8571e&scoped=true&"
import script from "./HeaderDetail.vue?vue&type=script&lang=js&"
export * from "./HeaderDetail.vue?vue&type=script&lang=js&"
import style0 from "./HeaderDetail.vue?vue&type=style&index=0&id=c5a8571e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a8571e",
  null
  
)

export default component.exports